<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <a class="libere-header-menu" data-bs-toggle="offcanvas" href="#offcanvasRight"
                            aria-controls="offcanvasRight" style="outline: none">
                            <div class="" style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/menu.svg#menu"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    メニュー
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 17px;">
                            <br>
                            <div style="font-weight: 600;font-size: 20px;line-height: 30px;">
                                九州離島 × 横浜の1,900kmの超遠距離を乗り越え Lunaで結婚！
                            </div>
                            <div style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:10px 0;">
                                2023年3月28日
                            </div>
                            <br>
                            <img src="/images/Group13345.png" class="img-fluid">
                            <div class="text-center"
                                style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:15px 0;">
                                まささん・男性20代 S 神奈川<br />
                                かすみさん・女性40代 M 神奈川
                            </div>
                            <br>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを始めたキッカケ</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">かすみ</span>：Lunaを始めたのは去年のコロナが猛威を奮っている時でしたね。コロナの療養中で隔離もされてて触るものが携帯しかなかったんです。<br />
                                それでとても手持ち無沙汰になってしまって、新しくTwitterのアカウントでも作ろうかなと思って、色々見ていたんです。そうしたらたまたまLunaがTwitterで流れてきました。<br />
                                もちろん、もともとSMが好きなのはあったのでSMについて検索をしていたのですが、偶然新しくTwitterのアカウントを作ったときがLunaのリリースした日でした。<br />
                                それで、非常に話題になっていたので目に止まったのがきっかけでした。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">まさ</span>：私ももともとSMに興味があったんです。<br />
                                LunaはTwitterで色々と調べている時に、リリースのタイミングであったのもあり、沢山の色んな人が呟いていてとても話題になってたので、知っていました。<br />
                                また、ちょうどその時緊縛を習ってたんです。それで興味を持ったのもありました。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaは始めた頃どんな印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">かすみ</span>：使ったときはSMなのに暗くない！というイメージでした。<br />
                                もともとSMが持っている怪しい雰囲気が一切なく女性にもとても使いやすかったです。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">まさ</span>：リリース直後なのに、思った以上に人がいて、マッチする数がとても多かったです。<br />
                                始めた直後から5-6人もマッチしてこれは想像以上にすっごくいいサービスだなと思いました！<br />
                                基本的にすべて無料でメッセージも無料でできるし、通常の出会い系サービスとは違って、SMに特化をしているにも関わらず、お金をかけずとも出会うことまでできるのがすごくいいです！<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>お相手とやり取りをしていてお相手はどのような印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">かすみ</span>：彼とやり取りをしはじめたのは、言葉で言えない何かを感じたのが大きかったですね。<br />
                                彼のTwitterのアイコンが狼なんですが、かわいいイラストなのにSって書いてあって、いわゆるバチバチなSという感じでがなく、優しい感じがあってとっても好印象でした。<br />
                                彼はすごく沢山マッチをしてたんですよ。でも、やり取りが続かない人とは全然続かないよと言っていて、実際私達はすごく続いていて毎日やり取りをしていましたね。<br />
                                <br /><br />
                                <span
                                    style="color:#6B4EFF">まさ</span>：そうですね、お互い会わないと分からないなとは思っていたので、会ったほうが手っ取り早いという話に早々になりましたね。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">かすみ</span>：そうですね、彼はとても話しやすい印象でした。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">まさ</span>：はい、すごく話しやすくて、息が合う感じがして、とてもいい人で良いなと思いました。<br />
                                実際に、話はずっと途切れませんでした。しかもその話の中でもちょこちょこと彼女の優しさが見え隠れしずっとすごく好印象でした。<br />
                                <br />
                                <br />
                                <span
                                    style="color:#6B4EFF">かすみ</span>：実は彼は一番最初、「はじめましてw」　「○○○○○w」　とかっていうタイプだったんですよ。笑う所でもないのにいつも最後に「w」をつけているタイプで、いい人なんですけれど、ずっと「w」をつけている人と会話をしたくないなと思って、思い切って彼に「笑うところでもないのに「w」を付けてると女子側としてはいい印象ではないですよ。」って言ってみたんです。<br />
                                そうしたら、「無意識で気づきませんでした。言ってくれてありがとうございます。」って素直に言われて驚いたんです。<br />
                                「最初からそんなこと言って、嫌な思いをしませんでしたか」って聞いたのですが、「むしろ自分のために言ってくれてありがとうございます。」って言われたので、すごく素直でいい人だなと思ったんです。<br />
                                最初はそんな形で始まったのですが、お話をしているうちにすごく意気投合し話が途切れることがなかったです。<br />
                                初めて電話した日なんかは3時間以上電話をしていて、夜中まで二人でお話をしてました。<br />
                                <br />
                                <img src="/images/report6.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>会ったときのお相手の印象</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">かすみ</span>：初めて会ったのは連絡を取り始めて1ヶ月くらい経った時でした。<br />
                                お互いお盆で実家に帰るタイミングがあって、たまたま二人とも関東だったんです。<br />
                                それで話して、東京で会おうとなりました。<br />
                                最初に会ったときの印象は、「この人は絶対に女ったらしだ」と思いました笑<br />
                                初めて会うのに最初っからすごく距離感が近くて、くっついてくる感じだったんです。<br />
                                もちろんメールや電話で仲良くしてたのはあったけど、私はすごく恥ずかしかったです笑<br />
                                <br />
                                <br />
                                <span
                                    style="color:#6B4EFF">まさ</span>：写真も交換してたし、電話でもいつも沢山話しをしていたので、普段どおりの距離感で接したつもりだったんですよ。なのに、そうしたら女ったらしだと思われたんです笑<br />
                                初めて会ったときは成田空港の空港だったのですが、飛行機が最終便だったので会えた時はもう最終電車があと5分で出発という状況でした。<br />
                                なので、本当はゆっくりと感動の対面をしたかったのですが、改めて挨拶する時間も全くなく、会ったらすぐにドタバタと電車まで走っていった感じでした。<br />
                                <br />
                                <br />
                                <span
                                    style="color:#6B4EFF">かすみ</span>：関東では数日ゆっくりしたのですが、お盆で帰省をしていただけだったので、一度そこから私が離島へ戻ったんです。そのためその間は3〜4ヶ月くらい遠距離での関係を続けていました。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>現在はどのようなご関係なんですか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">かすみ</span>：島に戻ったあとは、日々お話を重ねている中で、彼から関東にこないかという話をいただきました。それで悩みもしましたが、思い切って神奈川へ引っ越しをすることを決意しました。
                                島から神奈川に来てからは、結婚に関して彼の方からかなり積極的に話をすすめてくれました。それはすごく嬉しくて安心を致しました。<br />
                                もともと「結婚は夏以降にはしようね」と言っていたのですが、春くらいになって、どうせ結婚をするなら少しでも早くしよう！と言う話になって、どんどんと早めていって、トントン拍子に話が進んでいきました。<br />
                                そして2023年2月23日に入籍を無事することができました。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを使われる方へ一言</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">かすみ</span>：Lunaに限らず、マッチングサービスを利用する場合、最初は実際の対面ではないため、一人の人として向き合い丁寧にメッセージをやり取りすることがとても重要です。<br />
                                相手がどんな人であるか理解し、相手への興味を示すことで、良い関係を築いていくことができます。<br />
                                また、自分自身についても丁寧に話すことがとっても重要です。相手に自分自身をより深く理解してもらい、より良いつながりを築くことができます。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">まさ</span>：そうですね、最初は顔が見えないからこそ、信頼関係がとても大事だと思います。<br />
                                自分のことだけではなく、まずは、相手のことを知ることがとっても大事です。<br />
                                出会いなどの行動はそれからだと思っています。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">二人</span>：Lunaでなければ、私たちはお互い出会うことはなかったと思います。<br />
                                真剣な出会いを望んでいた私たちが、Lunaの出会いによって結ばれることができたことは、私たちにとって本当に嬉しかったです。<br />
                                Lunaを卒業してしまったものの、Lunaに出会うことができ、新しい出会いを得ることができました。そして、その出会いが幸せな結婚へと繋がりました。<br />
                                改めて、Lunaに感謝の気持ちとともに、お礼をお伝えしたいです。<br />
                                ありがとうございます。<br />
                            </div>
                            <br>
                            <br>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;" onclick="window.location.href = '/report/page2'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0" style="">
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13341.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">次のレポート</div>
                                        <div style="font-size:12px;">1年も経たずに良い従者に出会え、とても幸せです！</div>
                                    </div>
                                    <div class="col-2 px-0 text-center">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/>.svg#page_right"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import HeaderMenu from './../HeaderMenu.vue'
import Footer from './../FooterLogin.vue'

export default {
    data() {
        return {
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        Footer: Footer,
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #6B4EFF;
    text-decoration:none;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.item_box {
    padding: 30px 25px;
    background: #FFFFFF;
    border-radius: 10px;
}
</style>
